import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=ff1ace1a&scoped=true&"
import script from "./VideoLibrary.vue?vue&type=script&lang=js&"
export * from "./VideoLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&id=ff1ace1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1ace1a",
  null
  
)

export default component.exports